import { render, staticRenderFns } from "./PriceTwoTheme1.vue?vue&type=template&id=11791335&scoped=true"
import script from "./PriceTwoTheme1.vue?vue&type=script&lang=js"
export * from "./PriceTwoTheme1.vue?vue&type=script&lang=js"
import style0 from "./PriceTwoTheme1.vue?vue&type=style&index=0&id=11791335&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11791335",
  null
  
)

export default component.exports